
const staff = () => {
  if ($(".staff").length) {
    const $parent = $(".staff-categories");
    $parent.find(".add-and-hide").on("click", function () {
      const $category = $(this).parents(".category");
      const isActive = $category.hasClass("active");
      if (isActive) {
        $category.removeClass('active').find(".content").slideUp();
      }
      else {
        const oldActive = $parent.find(".category.active");
        oldActive.removeClass("active").find(".content").slideUp(300);
        $category.toggleClass('active').find(".content").slideDown(300, function () {
          if (oldActive.length > 0) {
            $("html").animate({
              scrollTop: $category.offset().top - 200
            }, 300);
          }
        })
      }
    });

    //default select
    $parent.find(".category .add-and-hide").first().click()
  }
}

module.exports = staff
